import { addFilter } from '@situation/setdesign.util';

addFilter('media-carousel/content-slider', (settings) => ({ ...settings, margin: 0 }));
